<template>
  <div class="pdf-preview position-relative mach-width mach-height">
    <div class="photo-view-tool position-absolute flex flex-row-align-center mach-width">
      <div class="photo-view-changerange flex-center">
        <img class="cursor" src="../../assets/icon-lib-source-photo-b.png" data-tp="larger" @click="sizechange">
        <img class="cursor" src="../../assets/icon-lib-source-photo-s.png" data-tp="smaller" @click="sizechange">
      </div>
      <div class="photo-view-mark flex-center">
        <img class="cursor" src="../../assets/icon-lib-source-mark.png" alt="" @click="showmark">
      </div>
      <div class="photo-view-mark flex-center">
        <img v-if="!isFull" class="cursor" src="../../assets/icon-lib-source-photofull.png" @click="showfull">
        <img v-else class="cursor" src="../../assets/icon-lib-source-unfull.png" @click="exitFull">
      </div>
    </div>
    <!-- <div class="mark" id="mark"></div> -->
    <div id="body-source-wrap-pdf" @touchmove.prevent="false">
      <div class="mach-height max-width pdf-wrap" @touchmove.prevent="false">
        <!-- <div class="scrollBox"> -->
          <span>123</span>
          
            <iframe name="myFrame" data-types="click" id="license_iframe" :src="src+'#toolbar=0'" scrolling="no"  ref="iframe" class="iframe" frameborder="0" @load="pdfload" @click.prevent="touchCancel"></iframe>
        
        
          <!-- <div class="flex-center" @click.prevent="touchCancel">
            <p v-if="!completeLoad" >正在加载中...</p>
          </div> -->
          <!-- <pdf v-for="item in numPages" :key="item" :src="src" :page="item" ref="pdf"></pdf> -->
        <!-- </div> -->
        <!-- <div class="pdfwrap" :style="{width:pdf_div_width, margin:'0 auto'}" style="maxWidth: 960px;">
          <canvas v-for="page in pdf_pages" :id="canvasid+page" :key="page" />
        </div> -->
      </div>
    </div>
    <!-- <div v-if="loading" class="loading-view position-absolute mach-height mach-width flex-center">
      <p class="font-color-white font-size-14">正在加载文件，请稍后...</p>
    </div> -->
  </div>
  
</template>
<script>
    import {
        getTopicPage
    } from '@/api/pdf'
  // window.onload = function function()
  // setit()
	// 	function setit() {
	// 		if(document.all) {
	// 			document.getElementById("license_iframe").attachEvent("click", dothis);
	// 		} else {
	// 			document.getElementById("license_iframe").contentWindow.addEventListener("click", dothis, false);
	// 		}
	// 	}

	// 	function dothis() {
	// 		console.log("blurred");
	// 		}

//获取iframe元
// iFrame = document.getElementById('license_iframe')
// console.log('iFrame333333333',iFrame);
// //iframe加载完毕后再发送消息，否则子页面接收不到message
// iFrame.onload = function(){
// //iframe加载完立即发送一条消息
//   iFrame.contentWindow.postMessage({msg: 'MessageFromIndexPage'},'\*');
// }
</script>

<script>
//       import {
//         getPdfHtml
//     } from '@/api/pdf'
// // let iFrame = document.getElementById('license_iframe')
// console.log('iFrame333333333',iFrame);
// iFrame.onload = function() {
//   console.log('iFrame2222',iFrame);
//   // iFrame.contentWindow.postMessage("this.src+'#toolbar=0'",'https://localhost:/9092');
// }
// let iframe = window.frames['myFrame']
// console.log('iframe 11111111',iframe );
// document.oncontextmenu = function (e) {
//             return false;
//         }
// var iframe = document.getElementById('license_iframe');
// console.log('iframe ----',iframe );
// iframe.onload=function(){
//   iframe.contentWindow.document.oncontextmenu=function(){return false;};
//   iframe.contentWindow.document.onselectstart=function(){return false;};
// };
// document.oncontextmenu = function(){
//       return false;
//     }
// document.oncontextmenu = function(){
// 		return false
// 	}

      // document.getElementById('mark').contentDocument.oncontextmenu = function(){
      //   return false;
      // }

// const PDFJS = require('pdfjs-dist')
// window.pdfjsWorker = require('pdfjs-dist/build/pdf.worker')
import pdf from 'vue-pdf'
export default {
  
  props: {
    src: {
      type: String,
      default: ''
    },
    isFull: {
      type: Boolean,
      default: false
    },
    canvasid: {
      type: String,
      default: 'the-canvas'
    }
  },
  components:{
    pdf
  },
  data() {
    return {
      intervalID: '',
            // ----- loading -----
      remindText: {
        loading: '加载文件中，文件较大请耐心等待...',
        refresh: '若卡住不动，可刷新页面重新加载...'
      },
      remindShow: '加载文件中，文件较大请耐心等待...',

      currentPage: 0,
      
      pageNum: 1,
       // 加载进度
      loadedRatio: 0, //当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成
  
      pdf_scale: 1.0, // pdf放大系数
      pdf_pages: [],
      pdf_div_width: '',
      pdfDoc: null,
      loading: false,
      resizing: false,

      scale: 100,
      scrollPosition: 0,
      pdfHeight: 0,
       numPages: null, // pdf 总页数
       completeLoad: false
    }
  },
  watch: {
    src() {
      // this._loadFile()
    },
    
   //iframe页面
  //  iframe: window.addEventListener('message',function(event){
    //此处执行事件 
    // var iwindow = iframe.contentWindow;
    //     console.log('iwindow++++++', iwindow);
    //     var idoc = iwindow.document;
    //     console.log('idoc=====', idoc);
        // console.log('iframe.contentDocument', iframe.contentDocument);
        // iframe.contentDocument.oncontextmenu = function() {
        //   return false
        // }
      //  this.pdfload()
  // }),
},
  mounted() {
console.log();
    // this. getPdfHtml()
    this.getNumPages()
    // this.src = pdf.createLoadingTask(this.src)  // 处理跨域问题
        // 更改 loading 文字
    this.intervalID = setInterval(() => {
      this.remindShow === this.remindText.refresh
        ? this.remindShow = this.remindText.loading
        : this.remindShow = this.remindText.refresh
    }, 4000)
    // 监听滚动条事件
    // this.listenerFunction()

    // window.addEventListener('scroll', this.handleScroll, true)
    // let doc = document.getElementById('body-source-wrap-pdf')
    // this.createIframe(doc, 'https://localhost:/9092/#/')

  },
  created() {
    // this._loadFile()
  },
  methods: {
  //   async getPdfHtml() {
  //     const res = await getPdfHtml( 
  //       {tenantId: this.$store.getters.tenantId,
  //         pdfFileName: this.src
  //       })
  //       console.log('res.data',res.data);
  // },
  //   window.οnlοad=function(){
  //     document.getElementById('iframe').contentDocument.oncontextmenu = function(){
  //       return false;
  //     }
  // },

    // document.oncontextmenu = function(){
    //   return false;
    // },
    pdfload(val) {
//       let myIframeDiv= document.getElementById('license_iframe')
//       let iframe = document.createElement('iframe')
// iframe.onload = () => {
// console.log('这样子就没问题了')
// }
// iframe.src = this.src +'#toolbar=0' //:src="src+'#toolbar=0'"// 就是这一行代码，一定要注意哦
// myIframeDiv.appendChild(iframe)
      // let iFrame = document.getElementById('license_iframe')
      // console.log('iFrame333333333',iFrame);
      // iFrame.contentWindow.postMessage("this.src+'#toolbar=0'",'https://localhost:/9092');

    //   setit()
		// function setit() {
		// 	if(document.all) {
    //     console.log('document.all',document.all);
		// 		document.getElementById("license_iframe").attachEvent("click", dothis);
		// 	} else {
		// 		// document.getElementById("license_iframe").contentWindow.addEventListener("click", dothis, false);
		// 	}
		// }

		// function dothis() {
		// 	console.log("blurred");
		// 	}
      // console.log('=========', val)
      // const iframe = document.getElementById('license_iframe')
      // console.log('iframe------------', iframe);

      // var iwindow = iframe.contentWindow
      // console.log('iwindow++++++', iwindow);
      // var idoc = iwindow.document
      // console.log('idoc++++++', iwindow);
      // iframe.contentDocument.oncontextmenu = function() {
      //   return false
      // }
      // this.completeLoad = true
     // window.onload = function()
      // /{
        // let iframe = document.getElementById('license_iframe').contentWindow
        // console.log('iframe------------', iframe);
        // let iframe = window.frames['myFrame']
        // let iframe = this.$refs.iframe.contentWindow
        // console.log('myFrame-----', iframe);
        // iframe.contentWindow.oncontextmenu=function(){return false;};
        // var iwindow = iframe.contentWindow.parent.self.frames
        // var iwindow = iframe.contentWindow.parent.self.frames['myFrame'] 
        // console.log('iwindow++++++', iwindow);
        // var idoc = iwindow.document;
        // console.log('idoc=====', idoc);
        // console.log('iframe.contentDocument', iframe.contentDocument);
        // iwindow.oncontextmenu = function() {
          // return false
        // }
     // }
    },
//       iframe.onload=function(){
//         iframe.contentWindow.document.oncontextmenu=function(){return false;};
// };
    // },
 
    // 监听滚动条事件
    // listenerFunction (e) {
    //   document.getElementById('body-source-wrap-pdf').addEventListener('scroll', this.handleScroll,true)
    // },
       // pdf加载时
    loadPdfHandler (e) {
      // 加载的时候先加载第一页
      this.currentPage = 1 
    },
    //计算pdf页码总数
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.src)
      console.log('loadingTask', loadingTask);
      console.log('this.src', this.src);
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
  
    handleScroll(e) {
      console.log(e.target.scrollTop)
      if (e.target.scrollTop) {
        this.scrollPosition = e.target.scrollTop
      }
    },
    _loadFile() { // 初始化pdf
      this.loading = true
      const CMAP_URL = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/'
      const loadingTask = PDFJS.getDocument({ url: this.src, cMapUrl: CMAP_URL, cMapPacked: true })
      loadingTask.promise
        .then((pdf) => {
          this.pdfDoc = pdf
          this.pdf_pages = this.pdfDoc.numPages
          this.$nextTick(() => {
            this._renderPage(1)
          })
        })
    },
    _renderPage(num) { // 渲染pdf页
      const that = this
      this.pdfDoc.getPage(num)
        .then((page) => {
          const canvas = document.getElementById(this.canvasid + num)
          const ctx = canvas.getContext('2d')
          const dpr = window.devicePixelRatio || 1
          const bsr = ctx.webkitBackingStorePixelRatio ||
              ctx.mozBackingStorePixelRatio ||
              ctx.msBackingStorePixelRatio ||
              ctx.oBackingStorePixelRatio ||
              ctx.backingStorePixelRatio || 1
          const ratio = dpr / bsr
          const viewport = page.getViewport({ scale: this.pdf_scale })

          canvas.width = viewport.width * ratio
          canvas.height = viewport.height * ratio
          canvas.style.width = viewport.width + 'px'
          that.pdf_div_width = viewport.width + 'px'
          canvas.style.height = viewport.height + 'px'
          that.pdfHeight = viewport.height
          ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
          const renderContext = {
            canvasContext: ctx,
            viewport: viewport
          }
          page.render(renderContext)
          if (this.pdf_pages > num) {
            this._renderPage(num + 1)
          } else {
            setTimeout(() => {
              that.loading = false
              that.resizing = false
            }, 500)
          }
        })
    },
    showfull() {
      this.$emit('fullscreen')
    },
    showmark() {
      this.$emit('showmark')
    },
    sizechange(t) {
      if (this.resizing) {
        return
      }
      const type = t.currentTarget.dataset.tp
      if (type === 'larger') {
        if (this.pdf_scale >= 3) {
          return
        }
        this.pdf_scale += 0.2
        this.scale += 10
        // this.$refs.pdfjs.style.transform = 'scale(' + this.scale + '%)'
      } else {
        if (this.pdf_scale <= 0.4) {
          return
        }
        this.pdf_scale -= 0.2
        this.scale -= 10
        // this.$refs.pdfjs.style.transform = 'scale(' + this.scale + '%)'
      }
      this.resizing = true
      this._renderPage(1)
      var that = this
      this.$nextTick(() => {
        setTimeout(() => {
          if (type === 'larger') {
            document.querySelector('#license_iframe').scrollTop = that.scrollPosition + that.pdfHeight * 0.2
          } else {
            document.querySelector('#license_iframe').scrollTop = that.scrollPosition - that.pdfHeight * 0.2
          }
        }, 0)
      })
    },
    exitFull() {
      this.$emit('exitFull')
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>

<style scoped>
  /* .bg-logo.addlogo {
      background-image: url(../../../assets/icon-cdsy.png);
      background-repeat: repeat;
      background-size: 300px;
      pointer-events: none;
  } */
  .pdf-preview {
    background-color: #191919 !important;
  }


 #body-source-wrap-pdf{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .scrollBox{
    width: 100%; 
    height: 100%;
  }
  #body-source-wrap-pdf .iframe {
      width: 100%;
      height: 100%;
      overflow:hidden;
      
  }
  .pdf-wrap {
    position: relative;
    /* overflow: scroll; */
  }
  .mark {
   
      height: 100%;
      /* margin-right: 40px; */
      position: absolute;
      top: 0;
      left: 0;
      right: 20px;
      bottom: 0px;
      opacity:0.99;
      z-index: 50;
    }
  .pdf-wrap::-webkit-scrollbar {  /*滚动条整体样式*/
  /* width : 3px;
  height: 1px; */
  }
  .pdf-wrap::-webkit-scrollbar-thumb {  /*滚动条里面小方块*/
  /* border-radius: 10px;
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background   : #535353; */
  }
  .pdf-wrap::-webkit-scrollbar-track { /*滚动条里面轨道*/
  /* box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background   : #999; */
  }

  .photo-view-tool {

    top: 10px;
    right: 40px;
    height: 30px;
    justify-content: flex-end;
    z-index: 100;
    padding: 0 0px;
  }

  .photo-view-changerange {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    background-color: #000;
  }

  .photo-view-changerange img {
    margin-right: 4px;
  }

  .photo-view-changerange img:last-child {
    margin: 0;
  }

  .photo-view-mark {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background-color: #000;
    margin-left: 5px;
  }

  .loading-view {
    top: 0;
    left: 0;
    background-color: #191919;
    z-index: 97;
  }

</style>
